import React, { useContext } from "react";
import { motion } from "framer-motion";
import { Typewriter } from "react-simple-typewriter";
// components
import SocialLinks from "../components/social/SocialLinks";
// other
import { aboutParagraph, HERO_TITLES } from "../mock/profile";
import { ScrollContext } from "../context/ScrollContext";
import ScrollToTop from "../components/ScrollToTop";
import { Icon } from "@iconify/react/dist/iconify.js";

// ----------------------------------------------------------------------

export default function HomeHero() {
  const { isScroll, jumpToDown } = useContext(ScrollContext);

  return (
    <div id="about">
      <section className="container mx-auto flex max-h-screen min-h-screen flex-col items-center justify-around px-5 md:px-1">
        <div className="relative  flex h-screen w-full">
          {/* <div className="z-20 hidden md:block">
          <img
            src="/assets/backImg/BackImg.png"
            className="w-full h-screen"
            alt="background"
          />
        </div> */}
          <div className="flex justify-center items-center z-50 p-2 sm:p-[10rem] h-full">
            <div className="font-sans text-center lg:text-left">
              <div className="font-bold mb-0 sm:mb-[3rem]">
                <p className="text-yellow-500 text-4xl sm:text-5xl ">
                  Hello,{" "}
                  <span className="text-white font-normal text-2xl sm:text-4xl mb-0 sm:mb-2">
                    my name is
                  </span>
                </p>
                <p
                  className="text-4xl sm:text-[80px] mt-5 font-[Ga+Maamli] text-transparent px-[20px] sm:px-[176px] text-[#69dadb]"
                  style={{ WebkitTextStroke: "1px #FFFFFF1A" }}
                >
                  Hussain Khaled
                </p>
              </div>
              <div className="text-3xl mt-6 h-9">
                <span className="text-primary-700 dark:text-primary-300 font-bold">
                  <Typewriter
                    style={{ color: "inherit" }}
                    words={HERO_TITLES}
                    loop={false}
                    cursor
                    cursorStyle=" "
                    typeSpeed={70}
                    deleteSpeed={50}
                    delaySpeed={1000}
                  />
                </span>
              </div>
              <div className="text-md mt-7">
                <div className="font-normal sm:font-medium text-base sm:text-[18px] font-[#94a5c5] leading-[20px] sm:leading-[2rem] text-[#d8d8dbc2]">
                  With over 7 years of hands-on experience in Full Stack and
                  Blockchain development, I specialize in crafting innovative
                  solutions for Blockchain, web3, NFTs, DeFi, Solana, Ethereum,
                  Wagmi, Smart Contracts, Rust and more. <br />
                  My strength is a smart contract development, leveraging
                  Solidity for EVM-compatible chains like Ethereum and BSC, as
                  well as for emerging ecosystems like Solana, Terra, Near, EOS,
                  among others.
                  <p>
                    I have a strong background in UX/UI design, ensuring
                    seamless user experiences, responsive interfaces, and
                    optimal performance. My focus on code quality using Tailwind
                    CSS and TypeScript has enabled me to build intuitive and
                    user-friendly projects.
                  </p>
                  <p className="py-4">Please feel free to contact me if you are looking for a developer.</p>
                </div>
              </div>
              <div className="flex justify-around items-end">
                <div className="mt-5">
                  <div className="flex items-center flex-wrap mt-12 gap-8 justify-center">
                    <a href="/resume.pdf" target="_blank">
                      <button class="relative group outline-none  w-fit m-transition-color text-dark-main  block   bg-gold-main">
                        <div class="absolute w-4/5 h-4/5 -top-1 -left-1 border-t border-l dark:border-yellow-500 border-gold-dark"></div>
                        <div class="absolute w-4/5 h-4/5 -bottom-1 -right-1 border-b border-r dark:border-white border-[#319960]"></div>
                        <div class="overflow-hidden w-full h-full relative px-4 py-2 bg-[#319960]">
                          <span class="absolute top-0 -left-full group-hover:left-0 w-full h-full duration-100 text-black bg-[#318a99] dark:bg-yellow-600 "></span>
                          <span class="relative z-10">Download CV</span>
                        </div>
                      </button>
                    </a>
                    <a href="#contact">
                      <button class="relative group outline-none  w-32 m-transition-color text-dark-main  block   bg-gold-main">
                        <div class="absolute w-4/5 h-4/5 -top-1 -left-1 border-t border-l dark:border-yellow-500 border-gold-dark"></div>
                        <div class="absolute w-4/5 h-4/5 -bottom-1 -right-1 border-b border-r dark:border-white border-[#319960]"></div>
                        <div class="overflow-hidden w-full h-full relative px-4 py-2 bg-[#319960]">
                          <span class="absolute top-0 -left-full group-hover:left-0 w-full h-full duration-100 text-black bg-[#318a99] dark:bg-yellow-600 "></span>
                          <span class="relative z-10">Hire Me</span>
                        </div>
                      </button>
                    </a>
                  </div>
                </div>
{/* 
                <div class="flex flex-row justify-between w-[100px] h-auto gap-9">
                  <div>
                    <a href="https://github.com/huska0707" aria-label="GitHub">
                      <Icon
                        icon="hugeicons:github"
                        className="w-[35px] h-[35px]"
                      />
                    </a>
                  </div>
                  <div>
                    <a
                      href="https://www.linkedin.com/in/hussain-khaled-65b546315"
                      aria-label="Linkedin"
                    >
                      <Icon
                        icon="uit:linkedin-alt"
                        className="w-[35px] h-[35px]"
                      />
                    </a>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
        <ScrollToTop />
      </section>
    </div>
  );
}

// ----------------------------------------------------------------------

HomeHero.propTypes = {};
